import React, { Fragment, useState, useMemo } from "react";
// import CancelIcon from "@mui/icons-material/Cancel";
import deleteIcon from "../../../assets/images/premiumService/Banner/delete.png";
import editIcon from "../../../assets/images/premiumService/editIcon.png";
const CampaignBannerList = ({
  data,
  onEditClick,
  onDeleteClick
}) => {
  const [sortDir] = useState(null); // 'asc' | 'desc' | null

  const sortedData = useMemo(() => {
    if (!data || !Array.isArray(data) || !sortDir) return data;
    const copy = [...data];
    copy.sort((a, b) => {
      const av = (a?.name || '').toString().toLowerCase();
      const bv = (b?.name || '').toString().toLowerCase();
      if (av < bv) return sortDir === 'asc' ? -1 : 1;
      if (av > bv) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
    return copy;
  }, [data, sortDir]);
  return <Fragment>
      {/* {sortedData && sortedData.length > 0 && (
         <div className="flex single-campaign" style={{ fontWeight: "bold", alignItems: 'center' }}>
           <p className="no-margin-bottom campaign-text" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
             Name
             <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
               <ArrowUpwardIcon
                 onClick={toggleAsc}
                 fontSize="small"
                 className="cursor"
                 color={sortDir === 'asc' ? 'primary' : 'inherit'}
                 style={{ marginBottom: '-4px' }}
               />
               <ArrowDownwardIcon
                 onClick={toggleDesc}
                 fontSize="small"
                 className="cursor"
                 color={sortDir === 'desc' ? 'primary' : 'inherit'}
                 style={{ marginTop: '-4px' }}
               />
             </span>
           </p>
           <div style={{ height: '100%' }} />
         </div>
        )} */}
      {sortedData && sortedData.map((item, index) => {
      return <div key={item.id || item.name || index} className="flex single-campaign">
              <p className="no-margin-bottom campaign-text">{item.name}</p>
              <div style={{
          height: "100%"
        }} className="flex">
                <div onClick={() => onEditClick(item)} className="cursor campaign-icons" title="Edit">
                
                  <img src={editIcon} alt="Edit" style={{
              width: 22,
              height: 22
            }} />
                </div>
                <div className="campaign-separator" />
                <div onClick={() => onDeleteClick(item)} className="cursor campaign-icons" title="Delete">
                  <img src={deleteIcon} alt="Delete" style={{
              width: 22,
              height: 22
            }} />
                </div>
              </div>
            </div>;
    })}
    </Fragment>;
};
export default CampaignBannerList;